"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_PASSWORD_CONSTRAINTS = exports.LOGIN_CONSTRAINTS = exports.confirmPassword = exports.password = exports.email = void 0;
exports.email = {
    presence: false,
    format: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Invalid email address',
    },
};
exports.password = {
    presence: false,
    format: {
        pattern: /^(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        message: 'Password must be 8 characters or more, including at least 1 number and 1 special character',
    },
};
exports.confirmPassword = {
    presence: false,
    equality: {
        attribute: 'password',
        message: 'Passwords are not same',
    },
};
exports.LOGIN_CONSTRAINTS = {
    email: exports.email,
    password: {
        presence: false,
        length: {
            // if we set minimum to 8, current users whose password is not 8 characters can't login
            minimum: 1,
            message: 'Password required',
        },
    },
};
exports.RESET_PASSWORD_CONSTRAINTS = {
    email: exports.email,
    password: exports.password,
    confirmPassword: exports.confirmPassword,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvY29uc3RyYWludHMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRVUsUUFBQSxLQUFLLEdBQUc7SUFDbkIsUUFBUSxFQUFFLEtBQUs7SUFDZixNQUFNLEVBQUU7UUFDTixPQUFPLEVBQUUsNEJBQTRCO1FBQ3JDLE9BQU8sRUFBRSx1QkFBdUI7S0FDakM7Q0FDRixDQUFDO0FBRVcsUUFBQSxRQUFRLEdBQUc7SUFDdEIsUUFBUSxFQUFFLEtBQUs7SUFDZixNQUFNLEVBQUU7UUFDTixPQUFPLEVBQUUsa0RBQWtEO1FBQzNELE9BQU8sRUFBRSw0RkFBNEY7S0FDdEc7Q0FDRixDQUFDO0FBRVcsUUFBQSxlQUFlLEdBQUc7SUFDN0IsUUFBUSxFQUFFLEtBQUs7SUFDZixRQUFRLEVBQUU7UUFDUixTQUFTLEVBQUUsVUFBVTtRQUNyQixPQUFPLEVBQUUsd0JBQXdCO0tBQ2xDO0NBQ0YsQ0FBQztBQUVXLFFBQUEsaUJBQWlCLEdBQUc7SUFDL0IsS0FBSyxFQUFMLGFBQUs7SUFDTCxRQUFRLEVBQUU7UUFDUixRQUFRLEVBQUUsS0FBSztRQUNmLE1BQU0sRUFBRTtZQUNOLHVGQUF1RjtZQUN2RixPQUFPLEVBQUUsQ0FBQztZQUNWLE9BQU8sRUFBRSxtQkFBbUI7U0FDN0I7S0FDRjtDQUNGLENBQUM7QUFFVyxRQUFBLDBCQUEwQixHQUFHO0lBQ3hDLEtBQUssRUFBTCxhQUFLO0lBQ0wsUUFBUSxFQUFSLGdCQUFRO0lBQ1IsZUFBZSxFQUFmLHVCQUFlO0NBQ2hCLENBQUMifQ==